import React from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { ExtraChargeWrapper, MoneyIcon, ExtraChargeName, Info } from './styles';

type Props = {
  reason: string;
};

const ExtraCharge = ({ reason }: Props) => {
  const { t } = useStoreTranslation();

  return (
    <ExtraChargeWrapper>
      <MoneyIcon />
      <div>
        <ExtraChargeName>{t('tripCard.extraCharge')}</ExtraChargeName>
        {reason !== '' && <Info>{reason}</Info>}
      </div>
    </ExtraChargeWrapper>
  );
};

export default ExtraCharge;
